module.exports = __webpack_public_path__ + "img/xin-back.559feaf9.png";